<template>

<div class="section-content pt-4" :class="{'mt-10' : $vuetify.breakpoint.xs , 'mt-n3' : $vuetify.breakpoint.sm}">
    <hb-header :divider="false" full>
        <hb-page-header
            title="Leads"
        >
        </hb-page-header>
    </hb-header>
    <div style="flex: 1" :class="{'filter-adjustment-hb-report': $vuetify.breakpoint.xs}">
        <hb-report
            :key="report_key"
            report_type="active_leads"
            :actions_panel="actions_panel_list"
            show_views
            right_click
            row_click="contact_view"
            show_search
            @rowClicked="viewLead"
            show_default_report_option="true"
            ref="HummingbirdReportViewer"
        ></hb-report>
    </div>

</div>
</template>


<script type="text/babel">
    import HbReport from '../assets/HummingbirdReportViewer.vue';
    import { EventBus } from "../../EventBus.js";
    export default {
        name: "Tenants",
        data() {
            return {
                report_key: 0,
            }
        },
        components:{
            HbReport

        },
        filters:{

        },
        computed:{
            actions_panel_list() {
                if(this.$vuetify.breakpoint.xs) {
                    return ['filters', 'export', 'save'];
                } else {
                    return ['advanced', 'filters', 'export', 'columns', 'save'];
                }
            }
        },
        created(){
              EventBus.$on('handleClick', this.handleClick);
              EventBus.$on('refetch_data', () => this.fetchData());
        },
        destroyed(){
              EventBus.$off('handleClick', this.handleClick);
              EventBus.$off('refetch_data', () => this.fetchData());
        },

        methods:{
            fetchData(){
                this.report_key++;
            },
            viewLead(data){
                this.$store.dispatch('navigationStore/openSlideOut', {
                    component: 'contact',
                    props: {
                        contact_id: data.lead_id,
                        view: "lead"
                    }
                });
            },
            handleClick(id){
                let payload = {
                    data:{
                        lead_id:id
                    }
                }
                this.$refs.HummingbirdReportViewer.handleRowClick(payload);
            }
        },

        watch:{
        }

    }
</script>
<style lang="scss"> 
.filter-adjustment-hb-report {
    .report-viewer-container {
        > div:nth-child(1) {
            > span > div > div > div {
                > div:nth-child(1) {
                    width: 50%;
                    margin-bottom: 6px !important;
                    .hb-autocomplete-wrapper {
                        width: unset !important;
                    }
                }
                > div:nth-child(2) {
                    display: none !important;
                }
                > div:nth-child(3) {
                    margin-bottom: 6px !important;
                    width: 50%;
                    .hb-text-field-wrapper {
                        width: unset !important;
                    }
                }
                > div:nth-child(4) {
                    margin-bottom: 0px !important;
                    margin-top: 0px !important;
                }
            }
        }
    }
}
</style>
<style scoped>
    .report-section-content{
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: stretch;
      justify-content: stretch;

    }
</style>
